// extracted by mini-css-extract-plugin
module.exports = {"error_icon":"styles_error_icon__3KpXM","error_content":"styles_error_content__1Mzki","error_context":"styles_error_context__2xmcL","footer_error":"styles_footer_error__2-aBk"};